(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["disc-box"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;

    const code = button.getAttribute('data-copy-code');

    navigator.clipboard.writeText(code).then(function () {
      button.classList.add('is-copied');
      setTimeout(function () {
        button.classList.remove('is-copied');
      }, 1800);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
